// extracted by mini-css-extract-plugin
export default {"root":"styles_root__gCVtf","avatar":"styles_avatar__1880K","role":"styles_role__gWy+t","action":"styles_action__+we-7","defaultLogo":"styles_defaultLogo__OVG3F"};